import { useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import { rage } from '~/rage';
import { AppBankFines } from '../../components/AppBankFines';
import { AppBankMain } from '../../components/AppBankMain';
import { AppBankOverlay } from '../../components/AppBankOverlay';
import { AppBankStartScreen } from '../../components/AppBankStartScreen';
import { AppBankTaxes } from '../../components/AppBankTaxes';
import { AppBankTransfer } from '../../components/AppBankTransfer';
import { BankStages } from '../../models/Bank';
import {
	setActiveBankState,
	setOverlayVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { StyledContainer, StyledWrapper } from './PhoneBank.styled';

const PhoneBank = () => {
	const dispatch = useLayoutDispatch();
	const activeBankState = useLayoutSelector(
		(state) => state.bank.activeBankState,
	);
	const overlayVisible = useLayoutSelector(
		(state) => state.bank.overlayVisible,
	);
	const [bankLocked, setBankLocked] = useState(true);

	useEffectOnce(() => {
		rage.bank.fetch().catch((err) => rage.notifications.showException(err));

		return () => {
			dispatch(setActiveBankState(BankStages.MAIN));
			dispatch(setOverlayVisible(false));
		};
	});

	return (
		<StyledWrapper>
			<SwitchTransition>
				<CSSTransition
					timeout={300}
					classNames="start"
					key={bankLocked ? 'locked' : 'unlocked'}
					addEndListener={(node, done) =>
						node.addEventListener('transitionend', done, false)
					}
				>
					{bankLocked ? (
						<AppBankStartScreen onSuccess={() => setBankLocked(false)} />
					) : (
						<StyledContainer>
							{activeBankState === BankStages.MAIN && <AppBankMain />}
							{activeBankState === BankStages.TRANSFER && <AppBankTransfer />}
							{activeBankState === BankStages.FINES && <AppBankFines />}
							{activeBankState === BankStages.TAXES && <AppBankTaxes />}
							<CSSTransition
								in={overlayVisible}
								timeout={300}
								classNames="overlay"
								unmountOnExit
							>
								<AppBankOverlay />
							</CSSTransition>
						</StyledContainer>
					)}
				</CSSTransition>
			</SwitchTransition>
		</StyledWrapper>
	);
};

export { PhoneBank };
